/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useContext } from 'react';
import Button from '../../@base/Button';
import Checkbox from '../../@base/Checkbox';
import Datatable from '../../@base/DataTable';
import EntityDetail from './EntityDetail';
import WatsonContext from '../../../context/WatsonContext';
import { showRemoveConfirmation } from '../Commons';

import style from './Entities.module.css';

const Entities = (props) => {
  const context = useContext(WatsonContext);

  const [showEntityDetail, setShowEntityDetail] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [selectedEntitiesToDelete, setSelectedEntitiesToDelete] = useState([]);

  /** Muda o estado do componente para mostrar a visão detalhada da entity */
  const detailing = (entity) => {
    if (entity) setSelectedEntity(entity);
    else setSelectedEntity(null);
    setShowEntityDetail(true);
  };

  /** Muda o  estado do componente para voltar a visão de listagem */
  const closeDetail = () => {
    setSelectedEntity(null);
    setShowEntityDetail(false);
  };

  /** Manipula ação de remoção das entities selecionadas */
  const deleteIntentsHandler = (entities) => {
    const entitiesToRemove = [].concat(entities);
    if (entitiesToRemove.length > 0) setSelectedEntitiesToDelete(entitiesToRemove);
  };

  /** Realiza remoção das intenções depois da confirmação  */
  const removeConfirmation = (selectedEntitiesToDeleteConfirmed) => {
    context.deleteIntentsOrEntities(
      'entities',
      [...selectedEntitiesToDeleteConfirmed],
      () => setSelectedEntitiesToDelete([]),
    );
  };

  /** Mostra a visão de listagem das entities */
  const showListView = () => {
    let entities = null;
    if (props.entities) {
      entities = Object.values(props.entities).map((x) => {
        const valores = x.values ? x.values.map((v) => v.value).join(', ') : null;
        return (
          <tr key={x.id}>
            <td>
              <Checkbox id={x.name} />
            </td>
            <td
              onClick={() => detailing(x)}
              onKeyPress={() => detailing(x)}
              data-th="Entidade"
            >
              {x.name}
            </td>
            <td
              onClick={() => detailing(x)}
              onKeyPress={() => detailing(x)}
              data-th="Valores"
            >
              {valores}
            </td>
          </tr>
        );
      });
    }

    return (
      <Datatable
        classes={`${style.Datatable} ${style.ScrollDatable}`}
        deleteRows={deleteIntentsHandler}
        actionsItems={(
          <Button
            primary
            small
            classes={style.Button}
            onClick={() => detailing()}
          >
            <small>Adicionar entiddade</small>
          </Button>
      )}
      >
        <table>
          <thead>
            <tr>
              <th scope="col" style={{ width: 60 }}>
                <Checkbox id="entity_check_all" />
              </th>
              <th scope="col" style={{ width: 200 }}>Entidade</th>
              <th scope="col">Valores</th>
            </tr>
          </thead>
          <tbody>{entities}</tbody>
        </table>
      </Datatable>
    );
  };

  /** Mostra a visão de detalhe da entidade */
  const showDetailView = () => (
    <EntityDetail
      closeEntityDetail={closeDetail}
      selectedEntity={selectedEntity}
    />
  );

  return (
    <>
      {showRemoveConfirmation(
        selectedEntitiesToDelete,
        removeConfirmation,
        setSelectedEntitiesToDelete,
      )}
      {showEntityDetail ? showDetailView() : showListView() }
    </>
  );
};

export default Entities;
